import { useCallback } from 'react';

import { useHistory, useParams } from 'react-router-dom';

import { URLPaths } from 'models/enums';

/**
 * A hook to get the type, folderId and the function to update both for the content page.
 * */
const useSegmentQueryManager = () => {
    const history = useHistory();
    let { folderId } = useParams<{ folderId: string | undefined }>();

    const numericFolderId = folderId === undefined ? -1 : Number(folderId);

    const basePath = `${URLPaths.SEGMENTS}`;

    const changeViewParams = useCallback(
        ({ newFolderId }: { newFolderId?: number } = {}) => {
            const getFolderPath = (newFolderId: number) => {
                if (newFolderId) {
                    return newFolderId === -1 ? '' : `${URLPaths.SEGMENTS_FOLDER}/${newFolderId}`;
                }
                return folderId ? `${URLPaths.SEGMENTS_FOLDER}/${folderId}` : '';
            };

            const folderPath = getFolderPath(newFolderId);

            // If we have a folder path, use it directly (it already includes the full path)
            // If no folder path, use the base segments path
            const path = folderPath ? folderPath : basePath;

            history.push(path);
        },
        [history, folderId, basePath]
    );

    return { folderId: numericFolderId, changeViewParams };
};

export default useSegmentQueryManager;
